import { Injectable } from '@angular/core';
import { User } from '../models/auth-user.model';

interface AmplitudeIdentify {
  add(property: string, value: number): AmplitudeIdentify;
}

interface AmplitudeClient {
  setUserProperties(properties: Record<string, unknown>): void;
  setUserId(userId: string): void;
}

interface AmplitudeSdk {
  clearUserProperties(): void;
  Identify: new () => AmplitudeIdentify;
  identify(identify: AmplitudeIdentify): void;
  logEvent(eventName: string, eventProperties?: Record<string, unknown>): void;
  getInstance(): AmplitudeClient;
}

declare global {
  interface Window {
    amplitude?: AmplitudeSdk;
  }
}

@Injectable({ providedIn: 'root' })
export class AmplitudeService {
  private amplitudeClient: AmplitudeClient | null = null;
  private readonly MAX_TRIES = 60;

  init(user?: User): void {
    this.getAmplitudeInstance();
    if (user) {
      this.setBaseEventProps(user);
    }
  }

  destroy(): void {
    window.amplitude?.clearUserProperties();
  }

  sendEvent(props: {
    title: string;
    pagePath: string;
    isKeyAction?: boolean;
    eventProperties?: object;
  }): void {
    const { title, pagePath, eventProperties, isKeyAction = true } = props;

    if (window.amplitude) {
      if (isKeyAction) {
        const identify = new window.amplitude.Identify().add('Total key-actions', 1);
        window.amplitude.identify(identify);
      }

      const eventData = {
        'É key-action?': isKeyAction ? 'Sim' : undefined,
        Página: pagePath,
        ...eventProperties,
      };

      window.amplitude.logEvent(title, eventData);
    }
  }

  private setBaseEventProps(user: User): void {
    const isInternal = /@(terramagna|internal\.terramagna|tmdigital)\.com\.br/.test(user.email);

    const props = {
      Empresa: user.client?.pretty_name,
      Divisão: user.division?.name,
      'É interno?': isInternal ? 'Sim' : 'Não',
      'Total key-actions': 0,
    };

    this.amplitudeClient?.setUserProperties(props);
    this.amplitudeClient?.setUserId(user.id);
  }

  private getAmplitudeInstance(attempt = 1): void {
    if (attempt === this.MAX_TRIES) return;
    if (window.amplitude) {
      this.amplitudeClient = window.amplitude.getInstance();
    } else {
      setTimeout(() => this.getAmplitudeInstance(attempt + 1), 1000);
    }
  }
}
